import axios from 'axios';

/**
 * Centralised API client for Royal Security frontend.
 *
 * Why this exists:
 * The production build of CRA bakes `process.env.REACT_APP_BACKEND_URL` into
 * the bundle at build time. When the bundle is then served from a different
 * origin (e.g. preview URL bundle running on royalsecurity.info) it triggers
 * cross-origin / CORS failures.
 *
 * To eliminate this class of bug we always derive the API base from the
 * current browser origin at runtime. Callers should NEVER reach for
 * process.env.REACT_APP_BACKEND_URL or window.location.origin directly for
 * API calls — import from this module instead.
 */

// Runtime-derived base URL. Falls back to relative `/api` if `window` is
// unavailable (e.g. during SSR / build-time inlining).
export const API_ORIGIN =
  typeof window !== 'undefined' && window.location ? window.location.origin : '';

export const API_BASE = `${API_ORIGIN}/api`;

const api = axios.create({
  baseURL: API_BASE,
  // 60s default — file uploads on /contact can be slow.
  timeout: 60000,
});

export default api;
